// @ts-nocheck
import {GameController, Horse, Joystick, SoccerBall, Spade, Ticket} from "@phosphor-icons/react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import championsIcon from "../../../assets/images/footer-logos/champion.svg";
import laligaIcon from "../../../assets/images/footer-logos/laliga.svg";
import lvbpIcon from "../../../assets/images/footer-logos/lvbp.svg";
import nbaIcon from "../../../assets/images/footer-logos/nba.svg";
import nflIcon from "../../../assets/images/footer-logos/nfl.svg";
import plus18Icon from "../../../assets/images/footer-logos/plus18.svg";
import RYGLogo from "../../../assets/images/coronando-logo.svg";
import playStore from "../../../assets/images/play-store.png";
import bgamingIcon from "../../../assets/images/providers-logos/providers-footer-logos/bgaming.svg";
import gamingcorpsIcon from "../../../assets/images/providers-logos/providers-footer-logos/gamingcorps.svg";
import hacksawIcon from "../../../assets/images/providers-logos/providers-footer-logos/hacksaw.svg";
import kagaIcon from "../../../assets/images/providers-logos/providers-footer-logos/kaga.svg";
import pixmoveIcon from "../../../assets/images/providers-logos/providers-footer-logos/pixmove.svg";
import pragmaticIcon from "../../../assets/images/providers-logos/providers-footer-logos/pragmatic.svg";
import upgamingIcon from "../../../assets/images/providers-logos/providers-footer-logos/upgaming.svg";
import RGC_logo from "../../../assets/images/RGC_Logo.png";
import facebookIcon from "../../../assets/images/social-media/facebookIcon.svg";
import instagramIcon from "../../../assets/images/social-media/instagramIcon.svg";
import {DownloadApp, SocialMedia} from "../../../config/config";
import {useAuthStore} from "../../../store/useAuth.store";
import {useUserSupport} from "../../../store/useUserSupport.store";

/* ─── Section title with centered gradient accent line ─────────────────── */
const SectionTitle = ({children}: {children: React.ReactNode}) => (
  <div className="flex items-center gap-2 mb-3">
    <span className="h-px flex-1 bg-[linear-gradient(90deg,rgba(215,50,168,0.45)_0%,transparent_100%)]" />
    <h3 className="text-[10px] font-bold uppercase tracking-[0.22em] text-[var(--color-text-secondary)] whitespace-nowrap m-0">
      {children}
    </h3>
    <span className="h-px flex-1 bg-[linear-gradient(270deg,rgba(215,50,168,0.45)_0%,transparent_100%)]" />
  </div>
);

/* ─── Shared chip classes ───────────────────────────────────────────────── */
const chipCls =
  "shrink-0 flex items-center gap-1.5 px-3 h-9 rounded-full " +
  "bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.09)] " +
  "text-[var(--color-text-secondary)] text-[12px] font-medium whitespace-nowrap " +
  "transition-all duration-200 cursor-pointer active:scale-95 " +
  "hover:bg-[linear-gradient(90deg,rgba(250,84,0,1)_0%,rgba(215,50,168,1)_100%)] " +
  "hover:text-[var(--color-ink-deep)] hover:border-transparent " +
  "hover:shadow-[0_4px_16px_-4px_rgba(215,50,168,0.5)]";

const scrollRowCls =
  "flex gap-2.5 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden pb-1 -mx-4 px-4";
const FooterRygMobile = () => {
  const navigate = useNavigate();

  const navigateAndScrollToTop = (path: string) => {
    navigate(path);
    setTimeout(() => window.scrollTo({top: 0, behavior: "smooth"}), 100);
  };

  const handleSupportModal = useUserSupport(state => state.handleSupportModal);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);
  const authStatus = useAuthStore(state => state.authStatus);
  const {t} = useTranslation();

  const isAuth = authStatus === "authenticated";
  const goTo = (path: string) => (isAuth ? () => navigateAndScrollToTop(path) : handleShowAuthModal);

  const gameItems = [
    {Icon: Joystick, label: t("footerTitleGameGames"), path: "/gameslist/all"},
    {Icon: Spade, label: t("footerTitleGameCasino"), path: "/casino"},
    {Icon: Ticket, label: t("footerTitleGameLottery"), path: "/lottery"},
    {Icon: SoccerBall, label: t("footerTitleSports"), path: "/sports"},
    {Icon: Horse, label: t("footerTitleGameHorses"), path: "/horses"},
    {Icon: GameController, label: t("footerTitleLigaEsports"), path: "/games/pragmatic/vplobby"},
  ];

  const providers = [
    {icon: pragmaticIcon, alt: "pragmatic", path: "/games/provider/pragmatic"},
    {icon: bgamingIcon, alt: "bgaming", path: "/games/provider/bgaming"},
    {icon: upgamingIcon, alt: "upgaming", path: "/games/provider/upgaming"},
    {icon: kagaIcon, alt: "kaga", path: "/games/provider/kaga"},
    {icon: hacksawIcon, alt: "hacksaw", path: "/games/provider/hacksaw"},
    {icon: gamingcorpsIcon, alt: "gamingcorps", path: "/games/provider/gamingcorps"},
    {icon: pixmoveIcon, alt: "pixmove", path: "/games/provider/pixmove"},
  ];

  const leagues = [
    {icon: championsIcon, alt: "champions", path: "/sports?page=uefa-champions"},
    {icon: nflIcon, alt: "nfl", path: "/sports?page=nfl"},
    {icon: laligaIcon, alt: "laliga", path: "/sports?page=laliga"},
    {icon: nbaIcon, alt: "nba", path: "/sports?page=nba"},
    {icon: lvbpIcon, alt: "lvbp", path: "/sports?page=lvbp"},
  ];

  const supportLinks = [
    {label: t("footerTitleHelp"), href: "https://soporte.aprietaygana/hc/help/es"},
    {label: t("footerTitleTerms"), href: "https://aprietaygana.com/terminos-y-condiciones"},
    {label: t("footerTitlePromotions"), href: "https://soporte.aprietaygana/hc/help/es/categories/promociones"},
    {label: t("footerTitleSupport"), onClick: handleSupportModal},
    {label: "News", onClick: isAuth ? () => navigate("/news") : handleShowAuthModal},
  ];

  return (
    <div className="w-full flex flex-col gap-6 pt-8 px-4 pb-36">

      {/* ── Brand Header ─────────────────────────────────────────── */}
      <div className="flex flex-col items-center gap-3">
        <img
          src={RYGLogo}
          alt="Coronando"
          className="w-14 h-auto"
        />
        <div className="flex gap-2.5">
          <a
            href={SocialMedia.FACEBOOK}
            target="_blank"
            rel="noreferrer"
            className="
              w-9 h-9 rounded-full flex items-center justify-center
              bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.1)]
              transition-all duration-200
              hover:bg-[rgba(215,50,168,0.2)] hover:border-[rgba(215,50,168,0.4)]
              hover:shadow-[0_0_12px_rgba(215,50,168,0.3)]
            "
          >
            <img
              src={facebookIcon}
              alt="Facebook"
              className="h-4 w-4 object-contain"
            />
          </a>
          <a
            href={SocialMedia.INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            className="
              w-9 h-9 rounded-full flex items-center justify-center
              bg-[rgba(255,255,255,0.06)] border border-[rgba(255,255,255,0.1)]
              transition-all duration-200
              hover:bg-[rgba(215,50,168,0.2)] hover:border-[rgba(215,50,168,0.4)]
              hover:shadow-[0_0_12px_rgba(215,50,168,0.3)]
            "
          >
            <img
              src={instagramIcon}
              alt="Instagram"
              className="h-4 w-4 object-contain"
            />
          </a>
        </div>
        <p className="text-[11px] text-[var(--color-text-tertiary)] text-center tracking-wide m-0">
          {t("footerTitleSocial")}
        </p>
      </div>

      {/* ── Game Categories — horizontal scroll chips ─────────── */}
      <div>
        <SectionTitle>{t("footerTitleGame")}</SectionTitle>
        <div className={scrollRowCls}>
          {gameItems.map(({Icon, label, path}) => (
            <button
              key={path}
              type="button"
              onClick={goTo(path)}
              className={chipCls}
            >
              <Icon
                size={14}
                weight="fill"
              />
              <span>{label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* ── Providers — horizontal scroll ────────────────────────── */}
      <div>
        <SectionTitle>Proveedores</SectionTitle>
        <div className={scrollRowCls}>
          {providers.map(({icon, alt, path}) => (
            <button
              key={alt}
              type="button"
              onClick={goTo(path)}
              className="
                shrink-0 h-11 px-3.5 rounded-xl cursor-pointer
                flex items-center justify-center
                bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.07)]
                transition-all duration-200 active:scale-95
                grayscale hover:grayscale-0
                hover:bg-[rgba(255,255,255,0.09)] hover:border-[rgba(215,50,168,0.3)]
                hover:shadow-[0_4px_14px_-4px_rgba(215,50,168,0.35)]
              "
            >
              <img
                src={icon}
                alt={alt}
                className="h-[22px] w-auto object-contain"
              />
            </button>
          ))}
        </div>
      </div>

      {/* ── Leagues — horizontal scroll ──────────────────────────── */}
      <div>
        <SectionTitle>{t("footerTitleLiga")}</SectionTitle>
        <div className={scrollRowCls}>
          {leagues.map(({icon, alt, path}) => (
            <button
              key={alt}
              type="button"
              onClick={goTo(path)}
              className="
                shrink-0 w-14 h-14 rounded-2xl cursor-pointer
                flex items-center justify-center
                bg-[rgba(255,255,255,0.04)] border border-[rgba(255,255,255,0.07)]
                transition-all duration-200 active:scale-95
                hover:bg-[rgba(255,255,255,0.09)] hover:border-[rgba(215,50,168,0.3)]
                hover:-translate-y-0.5 hover:shadow-[0_6px_18px_-6px_rgba(215,50,168,0.4)]
              "
            >
              <img
                src={icon}
                alt={alt}
                className="w-9 h-9 object-contain"
              />
            </button>
          ))}
        </div>
      </div>

      {/* ── Support links — 2-column grid ────────────────────────── */}
      <div>
        <SectionTitle>{t("footerTitleSupport")}</SectionTitle>
        <div className="grid grid-cols-2 gap-1.5">
          {supportLinks.map(({label, href, onClick}, i) =>
            href ? (
              <a
                key={href}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="
                  px-3 py-2.5 rounded-xl text-[12px] !text-[rgba(255,255,255,0.75)]
                  bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.06)]
                  transition-all duration-200 no-underline text-center leading-tight
                  hover:bg-[rgba(215,50,168,0.1)] hover:border-[rgba(215,50,168,0.3)]
                  hover:!text-white
                "
              >
                {label}
              </a>
            ) : (
              <button
                key={i}
                type="button"
                onClick={onClick}
                className="
                  px-3 py-2.5 rounded-xl text-[12px] !text-[rgba(255,255,255,0.75)]
                  bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.06)]
                  transition-all duration-200 cursor-pointer text-center leading-tight
                  hover:bg-[rgba(215,50,168,0.1)] hover:border-[rgba(215,50,168,0.3)]
                  hover:!text-white
                "
              >
                {label}
              </button>
            )
          )}
        </div>
      </div>

      {/* ── Trust strip ──────────────────────────────────────────── */}
      <div className="
        flex items-center gap-3 py-3 px-4 rounded-2xl
        bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.06)]
      ">
        <img
          src={plus18Icon}
          alt="18+"
          className="w-10 h-10 shrink-0 object-contain"
        />
        <div className="w-px h-8 bg-[rgba(255,255,255,0.1)] shrink-0" />
        <a
          href="https://www.responsiblegambling.org/"
          target="_blank"
          rel="noreferrer"
          className="shrink-0"
        >
          <img
            src={RGC_logo}
            alt="RGC"
            className="h-10 w-auto object-contain opacity-75 hover:opacity-100 transition-opacity"
          />
        </a>
        <div className="w-px h-8 bg-[rgba(255,255,255,0.1)] shrink-0" />
        <p className="text-[10px] text-[var(--color-text-tertiary)] leading-snug flex-1 m-0">
          {t("footerTitleResponsibleGambling")}
        </p>
      </div>

      {/* ── App download CTA ─────────────────────────────────────── */}
      <a
        href={DownloadApp.ANDROID}
        target="_blank"
        rel="noreferrer"
        className="
          flex items-center gap-4 h-16 px-5 rounded-2xl no-underline
          bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)]
          transition-all duration-200
          hover:bg-[rgba(255,255,255,0.08)] hover:border-[rgba(215,50,168,0.35)]
          hover:shadow-[0_6px_24px_-6px_rgba(215,50,168,0.3)]
          active:scale-[0.98]
        "
      >
        <img
          src={playStore}
          alt="Google Play"
          className="h-9 object-contain"
        />
        <div className="flex flex-col items-start gap-0.5">
          <span className="text-[10px] text-[var(--color-text-tertiary)] uppercase tracking-widest leading-none">
            {t("footerTitleApp")}
          </span>
          <span className="text-[14px] font-semibold text-[var(--color-text)] leading-none">
            Google Play
          </span>
        </div>
      </a>

      {/* ── Copyright ────────────────────────────────────────────── */}
      <p className="text-center text-[10px] text-[var(--color-text-tertiary)] tracking-wide m-0 pb-2">
        © {new Date().getFullYear()} Coronando &mdash; {t("footerTitleSafeGame")}
      </p>
    </div>
  );
};

export default FooterRygMobile;
